import { render, staticRenderFns } from "./ClassicWorks.vue?vue&type=template&id=509fde07&scoped=true"
import script from "./ClassicWorks.vue?vue&type=script&lang=js"
export * from "./ClassicWorks.vue?vue&type=script&lang=js"
import style0 from "./ClassicWorks.vue?vue&type=style&index=0&id=509fde07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509fde07",
  null
  
)

export default component.exports